import { render, staticRenderFns } from "./extra-style-photo-support.vue?vue&type=template&id=c69cf630&scoped=true&"
import script from "./extra-style-photo-support.vue?vue&type=script&lang=js&"
export * from "./extra-style-photo-support.vue?vue&type=script&lang=js&"
import style0 from "./extra-style-photo-support.vue?vue&type=style&index=0&id=c69cf630&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69cf630",
  null
  
)

export default component.exports